<template>
  <div>
    <component
      :is="tag"
      v-bind="$attrs"
      :class="inputClass"
      :style="inputStyle"
      ref="text"
      :contenteditable="editable"
      @input="update()"
      @blur="blur()">
    </component>
    <div class="level" v-if="(counter || hasError) && !hideDetails">
      <div class="help has-text-danger pl-1">
        <div 
          v-for="(error, i) in errors"
          :key="i">
          {{ error }}
        </div>
      </div>
      <span
        class="help"
        :class="{ 'has-text-danger': charactersRem < 0 }"
        v-if="counter">
        {{characters}}/{{counterValue}}
      </span>
    </div>
  </div>
</template>

<script>
import validatable from '@/mixins/validatable'

export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    value: {
      type: [String, Number]
    },
    editable: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String
    }
  },
  mixins: [validatable],
  data() {
    return {
      oDoc: null
    }
  },
  computed: {
    inputClass() {
      return {
        'editable-text': true,
        'is-danger': this.hasError
      }
    },
    inputStyle({ minWidth }) {
      return minWidth ? { 'min-width': minWidth } : null
    }
  },
  mounted() {
    this.initDoc();
  },
  methods: {
    initDoc() {
      this.oDoc = this.$refs["text"];
      if (this.value) {
        this.oDoc.innerHTML = this.value;
      }
    },
    update() {
      let oContent = document.createRange();
      oContent.selectNodeContents(this.oDoc);
      const contentStr = oContent.toString().trim();
      this.$emit("input", contentStr);
      this.validate(contentStr);
    },
    blur() {
      let oContent = document.createRange();
      oContent.selectNodeContents(this.oDoc);
      const contentStr = oContent.toString().trim();
      this.$emit("blur", contentStr);
    }
  }
}
</script>

<style lang="scss" scoped>
.editable-text[contenteditable="true"]{
  outline: none;
  padding: calc(0.5em - 1px) calc(0.75em - 1px);
  border-radius: 4px;
  background: white;
  border: 1px solid lightgrey;
  &:hover {
    border: 1px solid silver;
  }
  &:focus {
    outline: none;
    border: 1px solid #3273dc;
    box-shadow: 0 0 0 0.125em rgba(50,115,220,.25);
  }
  &.is-danger {
    border: 1px solid #f14668;
    &:focus {
      box-shadow:0 0 0 .125em rgba(241,70,104,.25);
    }
  }
}
</style>
